import { Navigate } from "react-router-dom";

const PrivateRoutes = ({ auth, children }) => {
  return auth ? children : <Navigate to="/login" />;
};

export default PrivateRoutes;
